import React from "react";
import { LuX, LuArrowLeft } from "react-icons/lu";

// Rendered header height: padding-top(10) + row(button padding 4 + icon 16 + padding 4 = 24)
// + padding-bottom(8) + border-bottom(1) = 43. Kept as a constant so callers that need to
// reserve room for the header (e.g. a flex sibling that must not squeeze it away) can reuse
// the real value instead of a guessed round number.
export const HEADER_HEIGHT = 43;

export default function RightPanelShell({ title, Icon, onClose, onBack, children, style }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        background: "white",
        ...style,
      }}
    >
      {/* Common header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 12px 8px",
          borderBottom: "1px solid #f1f5f9",
          flexShrink: 0,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
          {Icon && (
            <span style={{ color: "#a963f5", display: "flex", alignItems: "center" }}>
              <Icon style={{ width: 16, height: 16 }} />
            </span>
          )}
          <span
            style={{
              fontSize: 13,
              fontWeight: 600,
              color: "#1e293b",
              fontFamily: '"Inter", sans-serif',
            }}
          >
            {title}
          </span>
        </div>
        {(onBack || onClose) && (
          <button
            onClick={onBack || onClose}
            aria-label={onBack ? "back" : undefined}
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              padding: 4,
              borderRadius: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#94a3b8",
              transition: "background 0.12s, color 0.12s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#f1f5f9";
              e.currentTarget.style.color = "#1e293b";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "none";
              e.currentTarget.style.color = "#94a3b8";
            }}
          >
            {onBack ? <LuArrowLeft size={16} /> : <LuX size={16} />}
          </button>
        )}
      </div>

      {/* Panel content */}
      <div
        style={{
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </div>
    </div>
  );
}
